export interface FilterValue {
  id: number;
  slug: string;
  title: string;
}

export const filterValueFromResponse = (responseData: any): FilterValue => ({
  id: responseData.id,
  slug: responseData.slug,
  title: responseData.title,
});
